import { UserPlus, Calendar, FileSignature, TrendingUp } from "lucide-react";
const steps = [{
  icon: UserPlus,
  number: "1",
  title: "Entre em Contato",
  description: "Preencha o formulário abaixo e nosso time irá entrar em contato"
}, {
  icon: Calendar,
  number: "2",
  title: "Agendamento da Reunião",
  description: "Iremos agendar uma reunião para tirar as suas dúvidas e explicarmos os próximos passos da operação"
}, {
  icon: FileSignature,
  number: "3",
  title: "Assinatura de Contrato",
  description: "Assinamos um contrato para garantir que todo o processo seja transparente e seguro para toda as partes envolvidas no projeto"
}, {
  icon: TrendingUp,
  number: "4",
  title: "Copie Operações",
  description: "Configuramos a plataforma para replicar todas as operações dos nossos operadores de maneira automática"
}];
const HowItWorksSection = () => {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-secondary/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            <span className="text-foreground">Como Iniciar </span>
            <span className="bg-gradient-primary bg-clip-text text-transparent">Conosco</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Processo simples e transparente para iniciar seu copy trade
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative h-full">
                <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-elegant transition-all duration-300 text-center h-full flex flex-col">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-primary rounded-full mb-4 mx-auto">
                    <Icon className="w-8 h-8 text-primary-foreground" />
                  </div>
                  <div className="inline-flex items-center justify-center w-8 h-8 bg-accent text-accent-foreground rounded-full text-sm font-bold mb-4 mx-auto">
                    {step.number}
                  </div>
                  <h3 className="text-lg font-semibold mb-2 text-foreground">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm flex-grow">
                    {step.description}
                  </p>
                </div>
                {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-border"></div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
};
export default HowItWorksSection;